<div class="container">
  <app-account-side-nav />
  <div class="content-area">
    <div class="contact-us-title">We'd Like To Hear From You</div>
    <div class="contact-us-sub-title">
      Contact us with any questions you may have.
    </div>

    <form [formGroup]="contactUsForm" (ngSubmit)="sendEmail()">
      <div class="split left">
        <div class="name-fields-container">
          <div class="field">
            <label class="form-label"
              >First Name<span class="req">*</span></label
            >
            <input
              type="text"
              id="first-name"
              name="first-name"
              formControlName="firstName"
            />
            <div
              *ngIf="
          contactUsForm.controls['firstName']?.invalid &&
          (contactUsForm.controls['firstName'].dirty ||
            contactUsForm.controls['firstName'].touched) && 
            contactUsForm.controls['firstName'].errors?.['required']
        "
              class="error-message"
            >
              First name is required.
            </div>
          </div>
          <div class="field">
            <label for="last-name">Last Name<span class="req">*</span></label>
            <input
              type="text"
              id="last-name"
              name="last-name"
              formControlName="lastName"
            />
            <div
              *ngIf="
          contactUsForm.controls['lastName']?.invalid &&
          (contactUsForm.controls['lastName'].dirty ||
            contactUsForm.controls['lastName'].touched) && 
            contactUsForm.controls['lastName'].errors?.['required']
        "
              class="error-message"
            >
              Last name is required.
            </div>
          </div>
        </div>
        <div class="name-fields-container">
          <div class="field">
            <label for="Email">Email<span class="req">*</span></label>
            <input
              type="text"
              id="Email"
              name="Email"
              formControlName="email"
              (keydown)="clearEmailValidation()"
            />
            <div
              *ngIf="
                contactUsForm.controls['email']?.invalid &&
                (contactUsForm.controls['email'].dirty ||
                  contactUsForm.controls['email'].touched)
              "
            >
              <div *ngIf="invalidEmail" class="error-message">
                Email is invalid.
              </div>
              <div
                *ngIf="contactUsForm.controls['email'].errors?.['required']"
                class="error-message"
              >
                Email is required.
              </div>
            </div>
          </div>
          <div class="field">
            <label for="phone-number">Phone Number</label>
            <input
              type="text"
              id="phone-number"
              name="phone-number"
              formControlName="phone"
            />
          </div>
        </div>
        <div class="name-fields-container">
          <div class="field">
            <label for="company-name">Organization</label>
            <input
              type="text"
              id="company-name"
              name="company-name"
              formControlName="organizationName"
            />
          </div>
        </div>
        <div class="field">
          <label for="reason"
            >Please describe your reason for contacting<span class="req"
              >*</span
            ></label
          >
          <textarea
            id="reason"
            name="reason"
            class="text-area"
            rows="10"
            formControlName="message"
          ></textarea>
          <div
            *ngIf="
          contactUsForm.controls['message']?.invalid &&
          (contactUsForm.controls['message'].dirty ||
            contactUsForm.controls['message'].touched) && 
            contactUsForm.controls['message'].errors?.['required']
        "
            class="error-message"
          >
            A reason is required.
          </div>
        </div>
        <button class="button" type="submit" [disabled]="isSubmitting">Submit</button>
      </div>
    </form>
    <div class="split right">
      <div class="contact-info">
        <div class="location">
          <span class="material-icons">location_on</span>
          <p>11344 Coloma Road, Gold River, CA 95670.</p>
        </div>
        <div class="call">
          <span class="material-icons">call</span>
          <p>(866) 358-7099</p>
        </div>
        <div class="hours">
          <span class="material-icons">access_alarm</span>
          <p>Operation Hours</p>
        </div>
      </div>

      <div class="operation-hours">
        <table>
          <tr>
            <td>Monday</td>
            <td>6:00 AM - 5:00 PM / PST</td>
          </tr>
          <tr>
            <td>Tuesday</td>
            <td>6:00 AM - 5:00 PM / PST</td>
          </tr>
          <tr>
            <td>Wednesday</td>
            <td>6:00 AM - 5:00 PM / PST</td>
          </tr>
          <tr>
            <td>Thursday</td>
            <td>6:00 AM - 5:00 PM / PST</td>
          </tr>
          <tr>
            <td>Friday</td>
            <td>6:00 AM - 5:00 PM / PST</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</div>
